export enum ListenerEvents {
  CLICKAWAY = 'clickaway'
}
